{
  "activator": [
    { "name": "off", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "on",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 12, "s1": 0, "s2": 0 },
        { "hold": 12, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "andy": [
    {
      "name": "die 3",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 3, "s2": -19 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 3, "s2": -19 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 19, "s2": -8 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 19, "s2": -8 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": 7 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": 7 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -4, "s2": 3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -4, "s2": 3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -12, "s2": 3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -12, "s2": 3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -19, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -19, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -12, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -12, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 5, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 2, "s1": 0, "s2": 0 },
        { "hold": 10, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 5, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 2, "s1": 0, "s2": 0 },
        { "hold": 10, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 14, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 14, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "andyshot": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "artillery": [
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": -39 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": -39 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 17, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 17, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 39, "s2": -3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 39, "s2": -3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 31, "s2": 29 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 31, "s2": 29 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 36 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 36 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -32, "s2": 24 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -32, "s2": 24 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -36, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -36, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "move 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "move 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "artilleryshot": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "bullet": [
    { "name": "a 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "hq": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 38, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 38, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 },
        { "hold": 1, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "a 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "hrc": [
    { "name": "base 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base2 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base2 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base2 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "lri": [
    {
      "name": "die 3",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 3, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 3, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 12, "s2": -11 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 12, "s2": -11 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -7 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -7 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 7, "s2": 4 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 7, "s2": 4 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -4, "s2": 3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -4, "s2": 3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -8, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -8, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -13, "s2": -8 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -13, "s2": -8 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -5, "s2": -16 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -5, "s2": -16 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 16, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 16, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 16, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 23, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 16, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 23, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 6, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 17, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 6, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 17, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 5, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 21, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 5, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 21, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "move 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "ltank": [
    { "name": "base 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": -27 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 9, "s2": -27 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 19, "s2": -20 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 20, "s2": -11 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 25, "s2": -3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 25, "s2": 7 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 20, "s2": 17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 9, "s2": 19 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 24 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -8, "s2": 20 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -19, "s2": 16 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -21, "s2": 5 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -24, "s2": -3 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -21, "s2": -11 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -16, "s2": -16 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -9, "s2": -23 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "miner": [
    { "name": "run 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "mobilehq": [
    { "name": "run 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "run 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "movetarget": [
    {
      "name": "movetarget_0_0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "mtank": [
    { "name": "base 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -4, "s2": -21 },
        { "hold": 0, "s1": -4, "s2": -28 },
        { "hold": 0, "s1": 4, "s2": -24 },
        { "hold": 0, "s1": 4, "s2": -28 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 5, "s2": -19 },
        { "hold": 0, "s1": 8, "s2": -24 },
        { "hold": 0, "s1": 13, "s2": -17 },
        { "hold": 0, "s1": 16, "s2": -25 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -19 },
        { "hold": 0, "s1": 19, "s2": -23 },
        { "hold": 0, "s1": 19, "s2": -15 },
        { "hold": 0, "s1": 24, "s2": -20 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 16, "s2": -13 },
        { "hold": 0, "s1": 21, "s2": -16 },
        { "hold": 0, "s1": 21, "s2": -8 },
        { "hold": 0, "s1": 25, "s2": -11 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 24, "s2": -4 },
        { "hold": 0, "s1": 29, "s2": -4 },
        { "hold": 0, "s1": 27, "s2": 1 },
        { "hold": 0, "s1": 32, "s2": 1 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 28, "s2": 7 },
        { "hold": 0, "s1": 33, "s2": 11 },
        { "hold": 0, "s1": 23, "s2": 12 },
        { "hold": 0, "s1": 32, "s2": 15 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 23, "s2": 13 },
        { "hold": 0, "s1": 27, "s2": 19 },
        { "hold": 0, "s1": 17, "s2": 19 },
        { "hold": 0, "s1": 23, "s2": 23 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": 21 },
        { "hold": 0, "s1": 17, "s2": 27 },
        { "hold": 0, "s1": 8, "s2": 24 },
        { "hold": 0, "s1": 11, "s2": 29 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 4, "s2": 29 },
        { "hold": 0, "s1": 4, "s2": 35 },
        { "hold": 0, "s1": -4, "s2": 25 },
        { "hold": 0, "s1": -4, "s2": 35 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -7, "s2": 21 },
        { "hold": 0, "s1": -9, "s2": 29 },
        { "hold": 0, "s1": -11, "s2": 20 },
        { "hold": 0, "s1": -13, "s2": 28 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -16, "s2": 20 },
        { "hold": 0, "s1": -21, "s2": 25 },
        { "hold": 0, "s1": -19, "s2": 13 },
        { "hold": 0, "s1": -24, "s2": 19 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -19, "s2": 13 },
        { "hold": 0, "s1": -23, "s2": 16 },
        { "hold": 0, "s1": -21, "s2": 8 },
        { "hold": 0, "s1": -28, "s2": 12 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -24, "s2": 4 },
        { "hold": 0, "s1": -32, "s2": 4 },
        { "hold": 0, "s1": -24, "s2": -3 },
        { "hold": 0, "s1": -29, "s2": -3 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -19, "s2": -8 },
        { "hold": 0, "s1": -21, "s2": -9 },
        { "hold": 0, "s1": -16, "s2": -12 },
        { "hold": 0, "s1": -20, "s2": -15 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -17, "s2": -12 },
        { "hold": 0, "s1": -21, "s2": -16 },
        { "hold": 0, "s1": -11, "s2": -16 },
        { "hold": 0, "s1": -15, "s2": -20 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -12, "s2": -19 },
        { "hold": 0, "s1": -15, "s2": -24 },
        { "hold": 0, "s1": -4, "s2": -20 },
        { "hold": 0, "s1": -5, "s2": -25 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "mtower": [
    { "name": "base 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 16, "s2": 7 }] },
    { "name": "base 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 16, "s2": 7 }] },
    { "name": "base 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 16, "s2": 7 }] },
    {
      "name": "turret 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 9, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 21, "s2": -21 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 27, "s2": -12 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 28, "s2": -1 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 24, "s2": 11 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 21, "s2": 17 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 12, "s2": 25 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 27 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": 24 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -23, "s2": 20 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": -1 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -27, "s2": -13 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -20, "s2": -21 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "turret 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -11, "s2": -28 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "proc": [
    { "name": "base 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "door 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "miner 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "smoke",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 5, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "radar": [
    {
      "name": "a 0",
      "delay": 2,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 2,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "a 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "reactor": [
    {
      "name": "spin 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "spin 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "spin 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "replicator": [
    { "name": "a 0a", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "a 0b", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "b 0a", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "b 0b", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "l 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "research": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 6, "s1": 0, "s2": 0 },
        { "hold": 5, "s1": 0, "s2": 0 },
        { "hold": 6, "s1": 0, "s2": 0 },
        { "hold": 5, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "a 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "a 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "ricochet": [
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 2",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 3",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "rocket": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "trail",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "rtower": [
    { "name": "base 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 16, "s2": 7 }] },
    { "name": "base 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 16, "s2": 7 }] },
    { "name": "base 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 16, "s2": 7 }] },
    {
      "name": "turret  00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -5, "s2": -17 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -13 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 9, "s2": -17 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 19, "s2": -5 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 19, "s2": -5 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": 13 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 17, "s2": 8 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 3, "s2": 17 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 7, "s2": 17 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": 12 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -9, "s2": 17 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": 12 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -17, "s2": -5 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -17, "s2": -5 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -9, "s2": -17 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    {
      "name": "turret  15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -13, "s2": -19 },
        { "hold": 0, "s1": -13, "s2": -5 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "sexplosion": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "smoke": [
    {
      "name": "big 0",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "big 1",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "small 0",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "small 1",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "spi": [
    {
      "name": "die 3",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 10, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 20, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "sri": [
    {
      "name": "die 3",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -1, "s2": -23 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -1, "s2": -23 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -15 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -15 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 20, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 20, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 12, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 12, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -3, "s2": 16 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -3, "s2": 16 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -21, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -21, "s2": -5 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 15, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "idle 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "jog 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "tankshot": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "tmac": [
    { "name": "base 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": -24 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": -23 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 23, "s2": -19 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 25, "s2": -8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 25, "s2": -1 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 24, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 21, "s2": 20 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 15, "s2": 25 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 28 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -15, "s2": 24 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -24, "s2": 20 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -28, "s2": -11 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -23, "s2": -19 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -16, "s2": -24 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "troc": [
    { "name": "base 00", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 01", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 02", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 03", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 04", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 05", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 06", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 07", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 08", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 09", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 10", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 11", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 12", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 13", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 14", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "base 15", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    {
      "name": "fire 00",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 1, "s2": -17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 01",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 8, "s2": -16 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 02",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 13, "s2": -12 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 03",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 17, "s2": -8 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 04",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 17, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 05",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 17, "s2": 9 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 06",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 12, "s2": 13 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 07",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 9, "s2": 15 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 08",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 17 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 09",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -8, "s2": 13 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 10",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -12, "s2": 13 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 11",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -17, "s2": 8 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 12",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -17, "s2": 1 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 13",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -16, "s2": -4 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 14",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -13, "s2": -12 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "fire 15",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": -7, "s2": -15 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "upgrades": [
    { "name": "hrc1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "vts1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "bullpup1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "vacuum": [
    {
      "name": "a 0",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 2",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 3",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 4",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 5",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 6",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 7",
      "delay": 1,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "vexplosion": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "vts": [
    { "name": "a 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "a 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "a 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "b 0", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "b 1", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "b 2", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ],
  "wall": [
    {
      "name": "a",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "b",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    }
  ],
  "warehouse": [
    {
      "name": "a 0",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 1",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    {
      "name": "a 2",
      "delay": 0,
      "loop": false,
      "frames": [
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 },
        { "hold": 0, "s1": 0, "s2": 0 }
      ]
    },
    { "name": "icon", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "help", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] },
    { "name": "highlight", "delay": 0, "loop": false, "frames": [{ "hold": 0, "s1": 0, "s2": 0 }] }
  ]
}
